import React from 'react'

import { client } from 'config/routes'

import { HeaderLink } from './HeaderLink'

export const BoxPricesLink = () => <HeaderLink href={client.boxPrices} text="box prices" />
